import { render, staticRenderFns } from "./RatingTable.vue?vue&type=template&id=4456775f&"
import script from "./RatingTable.vue?vue&type=script&lang=js&"
export * from "./RatingTable.vue?vue&type=script&lang=js&"
import style0 from "./RatingTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VPagination,VRating})
